import { render, staticRenderFns } from "./Year_book.vue?vue&type=template&id=1a50780a&scoped=true"
import script from "./Year_book.vue?vue&type=script&lang=js"
export * from "./Year_book.vue?vue&type=script&lang=js"
import style0 from "./Year_book.vue?vue&type=style&index=0&id=1a50780a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50780a",
  null
  
)

export default component.exports